import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const ProductSliderDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  addToCartOptions: null,
  attributionToken: null,
  context: null,
  products: [],
  refetchCart: () => {},
  slidesToShow: 4,
};

export const ProductSliderPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  addToCartOptions: PropTypes.shape({}), // Defined in /blocks/Products/Product/Product
  attributionToken: PropTypes.string,
  context: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  refetchCart: PropTypes.func,
  slidesToShow: PropTypes.number,
};
